// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.CustomRepeatPopup__form-eca598 {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  padding: 24px;
  gap: 24px;
}

.CustomRepeatPopup__container-fbdb06 {
  display: flex;
  align-items: center;
}

.CustomRepeatPopup__interval-field-b09d5d,
.CustomRepeatPopup__number-occurrences-field-e9be27 {
  width: 60px;
  margin-inline-end: 8px;
}

/* 1. Для Chrome, Safari, Edge, Opera */
.CustomRepeatPopup__interval-field-b09d5d input[type=number]::-webkit-outer-spin-button,
.CustomRepeatPopup__interval-field-b09d5d input[type=number]::-webkit-inner-spin-button,
.CustomRepeatPopup__number-occurrences-field-e9be27 input[type=number]::-webkit-outer-spin-button,
.CustomRepeatPopup__number-occurrences-field-e9be27 input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 2. Для Firefox */
.CustomRepeatPopup__interval-field-b09d5d input[type=number],
.CustomRepeatPopup__number-occurrences-field-e9be27 input[type=number] {
  -moz-appearance: textfield;
}

.CustomRepeatPopup__type-field-ed5fae {
  width: 126px;
}

.CustomRepeatPopup__same-day-field-d0d532 {
  margin-bottom: 8px;
}

.CustomRepeatPopup__text-b35cca {
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-inline-end: auto;
}

.CustomRepeatPopup__filters-ac6749 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.CustomRepeatPopup__radio-label-title-f45ff8 {
  font: var(--font-body-4);
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/Popup/CustomRepeatPopup/CustomRepeatPopup.styles.m.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;;EAEE,WAAA;EACA,sBAAA;AAEF;;AACA,uCAAA;AACA;;;;EAIE,wBAAA;EACA,SAAA;AAEF;;AACA,mBAAA;AACA;;EAEE,0BAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,uBAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAEF;;AACA;EACE,wBAAA;AAEF","sourcesContent":[".form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n  gap: 24px;\n}\n\n.container {\n  display: flex;\n  align-items: center;\n}\n\n.interval-field,\n.number-occurrences-field {\n  width: 60px;\n  margin-inline-end: 8px;\n}\n\n/* 1. Для Chrome, Safari, Edge, Opera */\n.interval-field input[type='number']::-webkit-outer-spin-button,\n.interval-field input[type='number']::-webkit-inner-spin-button,\n.number-occurrences-field input[type='number']::-webkit-outer-spin-button,\n.number-occurrences-field input[type='number']::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* 2. Для Firefox */\n.interval-field input[type='number'],\n.number-occurrences-field input[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.type-field {\n  width: 126px;\n}\n\n.same-day-field {\n  margin-bottom: 8px;\n}\n\n.text {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-inline-end: auto;\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.radio-label-title {\n  font: var(--font-body-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `CustomRepeatPopup__form-eca598`,
	"container": `CustomRepeatPopup__container-fbdb06`,
	"interval-field": `CustomRepeatPopup__interval-field-b09d5d`,
	"intervalField": `CustomRepeatPopup__interval-field-b09d5d`,
	"number-occurrences-field": `CustomRepeatPopup__number-occurrences-field-e9be27`,
	"numberOccurrencesField": `CustomRepeatPopup__number-occurrences-field-e9be27`,
	"type-field": `CustomRepeatPopup__type-field-ed5fae`,
	"typeField": `CustomRepeatPopup__type-field-ed5fae`,
	"same-day-field": `CustomRepeatPopup__same-day-field-d0d532`,
	"sameDayField": `CustomRepeatPopup__same-day-field-d0d532`,
	"text": `CustomRepeatPopup__text-b35cca`,
	"filters": `CustomRepeatPopup__filters-ac6749`,
	"radio-label-title": `CustomRepeatPopup__radio-label-title-f45ff8`,
	"radioLabelTitle": `CustomRepeatPopup__radio-label-title-f45ff8`
};
module.exports = ___CSS_LOADER_EXPORT___;
